import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchRoomRestriction } from "../../../Services/BON-Frontend/Service";

export const fetchRoomRestriction = createAsyncThunk(
  "frontRoomRestriction/fetchRoomRestriction",
  async (
    { requestKey, PropertyID, CheckInDate, CheckOutDate, RateCode,RoomCode },
    { rejectWithValue }
  ) => {
    try {
      const response = await FetchRoomRestriction(
        PropertyID,
        CheckInDate,
        CheckOutDate,
        RateCode,
        RoomCode
      );

      const result = Array.isArray(response) ? response[0] : response;

      return {
        requestKey,
        restricted: String(result) === "0",
      };
    } catch (error) {
      return rejectWithValue({
        requestKey,
        error: error?.message || "Unable to check room availability.",
      });
    }
  }
);

const roomRestrictionSlice = createSlice({
  name: "frontRoomRestriction",
  initialState: {
    byRequestKey: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoomRestriction.pending, (state, action) => {
        const { requestKey } = action.meta.arg;
        state.byRequestKey[requestKey] = {
          loading: true,
          restricted: false,
          error: null,
        };
      })
      .addCase(fetchRoomRestriction.fulfilled, (state, action) => {
        const { requestKey, restricted } = action.payload;
        state.byRequestKey[requestKey] = {
          loading: false,
          restricted,
          error: null,
        };
      })
      .addCase(fetchRoomRestriction.rejected, (state, action) => {
        const requestKey =
          action.payload?.requestKey || action.meta.arg.requestKey;

        state.byRequestKey[requestKey] = {
          loading: false,
          restricted: false,
          error:
            action.payload?.error ||
            action.error?.message ||
            "Unable to check room availability.",
        };
      });
  },
});

export default roomRestrictionSlice.reducer;
